import React from 'react';

interface AiNativeIconProps {
  size?: number;
  color?: string;
  className?: string;
}

const AiNativeIcon: React.FC<AiNativeIconProps> = ({
  size = 24,
  color = 'currentColor',
  className
}) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 23 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M6.1543 8.25879C5.94015 8.67577 5.67448 9.04885 5.34766 9.37305C5.02572 9.69236 4.65697 9.95196 4.24707 10.1611C4.65794 10.373 5.02642 10.6364 5.34863 10.958C5.67428 11.2831 5.94053 11.6562 6.1543 12.0723C6.36741 11.6562 6.6338 11.2842 6.95898 10.959C7.28082 10.6371 7.64869 10.3731 8.05957 10.1611C7.65 9.95203 7.28231 9.69223 6.96094 9.37305C6.63449 9.04873 6.36783 8.67581 6.1543 8.25879ZM6.85742 4.70215C6.85749 6.55009 7.25467 7.68791 7.94922 8.37793C8.64473 9.06871 9.78347 9.45502 11.6104 9.45508C11.9977 9.45508 12.3125 9.76893 12.3125 10.1562C12.3125 10.5436 11.9977 10.8574 11.6104 10.8574C9.78792 10.8575 8.6474 11.253 7.9502 11.9502C7.25299 12.6474 6.85749 13.7879 6.85742 15.6104C6.85742 15.9977 6.54357 16.3125 6.15625 16.3125C5.76893 16.3125 5.45508 15.9977 5.45508 15.6104C5.45501 13.7893 5.05699 12.6488 4.3584 11.9512C3.65939 11.2533 2.51821 10.8575 0.702148 10.8574C0.314832 10.8574 0 10.5436 0 10.1562C0 9.76893 0.314832 9.45508 0.702148 9.45508C2.52289 9.45502 3.6621 9.06855 4.35938 8.37695C5.05547 7.6865 5.45501 6.54888 5.45508 4.70215C5.45508 4.31483 5.76893 4 6.15625 4C6.54357 4 6.85742 4.31483 6.85742 4.70215Z'
      fill={color}
    />
    <path
      d='M19.2976 13.4561C19.684 13.4563 19.9969 13.7698 19.9969 14.1562C19.9969 14.5427 19.684 14.8562 19.2976 14.8564H11.4676C11.081 14.8564 10.7674 14.5428 10.7674 14.1562C10.7674 13.7697 11.081 13.4561 11.4676 13.4561H19.2976ZM22.0672 9.46484C22.4536 9.46484 22.7672 9.77764 22.7674 10.1641C22.7674 10.5507 22.4538 10.8643 22.0672 10.8643H14.8181C14.4315 10.8643 14.1179 10.5507 14.1179 10.1641C14.1182 9.77764 14.4317 9.46484 14.8181 9.46484H22.0672ZM19.2976 5.45605C19.684 5.4563 19.9969 5.7698 19.9969 6.15625C19.9969 6.5427 19.684 6.8562 19.2976 6.85645H11.4676C11.081 6.85645 10.7674 6.54285 10.7674 6.15625C10.7674 5.76965 11.081 5.45605 11.4676 5.45605H19.2976Z'
      fill={color}
    />
  </svg>
);

export default AiNativeIcon;
